import React , {useState,useEffect} from 'react';
import Chart from 'react-apexcharts'
const ClassGroupOveview = (props) => {
    const { studentData } = props;
    console.log(studentData.data,studentData.labels)
    const formatData  =(chartObj)=>{
        return {
            options: {
                chart: {
                    stacked: false,
                },
                stroke: {
                    width: [0, 2, 5],
                    curve: 'smooth'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: chartObj.labels,
                markers: {
                    size: 0
                },
                xaxis: {
                    type: 'datetime'
                },
                yaxis: {
                    min: 0,
                    "labels": {
                        "formatter": function (val) {
                            return parseInt(val)
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                },
                legend: {
                    offsetY: 6,
                }
            },
            series: chartObj.data
        }
    }
    const [chartData, setChartData] = useState(formatData(studentData))
    useEffect(() => {
        setChartData(formatData(studentData))
    }, [studentData])
    return (
      <>
         <div id="chart">
                 <Chart options={chartData.options} series={chartData.series} type="line" height="450" />
             </div>
      </>
    );
  };
  
  export default ClassGroupOveview;
